import { render, staticRenderFns } from "./ResettledBucketCompare.vue?vue&type=template&id=fe82dba6&web=true&"
import script from "./ResettledBucketCompare.vue?vue&type=script&lang=ts&"
export * from "./ResettledBucketCompare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
